import type { InstagramPostBlockProps } from './types';
import { useEffect } from 'react';

export type { InstagramPostBlockProps };

export function InstagramPostBlock({ instagramPostEmbed }: InstagramPostBlockProps) {
  useEffect(() => {
    if (!document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div  dangerouslySetInnerHTML={{ __html: instagramPostEmbed }} />
  );
}
